// The Builder's root: it opens the projects for a signed-in user and redirects anyone else to its
// sign-in page. Never link to /sign-in itself, which signs a signed-in user out. Without a local
// .env the production Builder is used, so the buttons never point at "undefined".
export const RELEASE_URL: string =
  import.meta.env.VITE_RELEASE_URL || 'https://dhcs.fuselabcreative.com';
